import React from 'react';
import { REDUCER_NAME } from '../reducer';
import { connect } from 'react-redux';
import { compose } from 'redux';
import TablePutThrough from './TablePutThrough';
import { I18n } from 'react-redux-i18n';

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    listDataRealTimePutThrough: state[REDUCER_NAME].listDataRealTimePutThrough,
    listPutThroughHose: state[REDUCER_NAME].listPutThroughHose,
  };
};

const enhance = compose(connect(mapStateToProps));

export default enhance(TablePutThroughAsk);

function TablePutThroughAsk(props) {
  const { listDataRealTimePutThrough, listPutThroughHose } = props;
  const realTimeData = listDataRealTimePutThrough.VNINDEX;
  return (
    <TablePutThrough
      {...props}
      realTimeData={realTimeData}
      data={listPutThroughHose}
      name={I18n.t(`watchListSummary.listTitleTablePutThrough.hose`)}
    />
  );
}
